import { Expose, plainToInstance } from "class-transformer";
import { IsDate, IsNotEmpty, IsString } from "class-validator";

export class ContractorDocument {
  public static from(contractorDocument: ContractorDocument) {
    return plainToInstance(ContractorDocument, contractorDocument);
  }
  @Expose()
  @IsString()
  @IsNotEmpty()
  id!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  name!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  uri!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  kind!: string;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  expirationDate!: Date;

  @Expose()
  @IsString()
  @IsNotEmpty()
  licenseNumber!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  policyNumber!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  confirmationLink?: string;
}
